import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.regexp.split";
import _slicedToArray from "/app/node_modules/@babel/runtime-corejs2/helpers/slicedToArray";
import "core-js/modules/es6.function.name";
import _regeneratorRuntime from "/app/node_modules/@babel/runtime-corejs2/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/app/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.set";
import _toConsumableArray from "/app/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es7.object.values";

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { API_REQUEST } from '@/api/';
import { i18n } from '@/boot/i18n.js';
import { getIndexedCollection } from '@/common/helpers'; // import { dataF, dataL } from '@/../test/jest/__mocks__/forecast-data'

/**
 * @typedef {object} LoadedChartData
 * @property {string} queryKey
 * @property {{dttm_forecast: string, value: number}[]} forecastChartData
 */

var cachedChartData = {};
var cachedRowData = {};
var cachedSum = {};
var requestCache = {};
var lastFromTo = '';
var state = {
  treeNodes1: [],
  treeNodes2: [],
  treeNodes3: [],
  treeNodes4: [],
  labelById: {},
  selectedTreeNodes: []
};
/**
 * @param {Object<string, LoadedChartData>} loadedChartData
 */

function getChartXValues(loadedChartData) {
  var dateArr = Object.values(loadedChartData).map(function (el) {
    return el.forecastChartData;
  }).flat().map(function (el) {
    return el.dttm_forecast;
  });

  var uniqueDates = _toConsumableArray(new Set(dateArr)).sort(function (a, b) {
    return Date.parse(a) - Date.parse(b);
  });

  return {
    dates: uniqueDates.map(function (el) {
      return new Date(el);
    }),
    dateStrings: uniqueDates
  };
}

var mutations = {
  setTreeNodes: function setTreeNodes(state, _ref) {
    var index = _ref.index,
        value = _ref.value;
    state["treeNodes".concat(index)] = value;
  },
  addLabelsById: function addLabelsById(state, newLabelsById) {
    Object.assign(state.labelById, newLabelsById);
  },
  cleanLabelsById: function cleanLabelsById(state) {
    state.labelById = {};
  },
  setSelectedTreeNodes: function setSelectedTreeNodes(state, val) {
    state.selectedTreeNodes = val;
  }
};
var actions = {
  init: function init(_ref2) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var dispatch;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              dispatch = _ref2.dispatch;
              _context.next = 3;
              return dispatch('updateTrees');

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  updateTrees: function updateTrees(_ref3) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var rootGetters, commit, buildTree, res, businessDriversRes, operationsRes, workTypesRes, additionalTags;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              buildTree = function _buildTree(filteredItems) {
                var labelsById = {};
                var result = filteredItems.map(function (item) {
                  labelsById[item['id']] = item['operation_type_name']['name'];
                  var node = {
                    label: item['operation_type_name']['name'],
                    value: item['id'],
                    children: [{
                      label: i18n.t('mainTerms.plan'),
                      value: 'PLAN_' + item['id']
                    }, {
                      label: i18n.t('mainTerms.fact'),
                      value: 'FACT_' + item['id']
                    }]
                  };
                  return node;
                });
                commit('addLabelsById', labelsById);
                return result;
              };

              rootGetters = _ref3.rootGetters, commit = _ref3.commit;
              _context2.next = 4;
              return API_REQUEST('getOperationTypes', {
                'shop_id': rootGetters['queryMirrored/getOneDep']
              });

            case 4:
              res = _context2.sent;
              businessDriversRes = res[1].filter(function (item) {
                return item['operation_type_name']['do_forecast'] === 'H';
              });
              operationsRes = res[1].filter(function (item) {
                return item['operation_type_name']['do_forecast'] === 'F' && item['work_type_id'] === null;
              });
              workTypesRes = res[1].filter(function (item) {
                return item['operation_type_name']['do_forecast'] === 'F' && item['work_type_id'] !== null;
              });
              additionalTags = res[1].filter(function (item) {
                return item['operation_type_name']['do_forecast'] === 'FS';
              });
              commit('cleanLabelsById');
              commit('setTreeNodes', {
                index: 1,
                value: buildTree(businessDriversRes)
              });
              commit('setTreeNodes', {
                index: 2,
                value: buildTree(operationsRes)
              });
              commit('setTreeNodes', {
                index: 3,
                value: buildTree(workTypesRes)
              });
              commit('setTreeNodes', {
                index: 4,
                value: buildTree(additionalTags)
              });
              commit('application/setPrimaryPageLoaded', {
                value: true
              }, {
                root: true
              });

            case 15:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },
  getChartData: function getChartData(_ref4) {
    var _arguments = arguments;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var rootGetters, rootState, _ref5, lineIds, _ref5$updateCache, updateCache, chartData, chartSums, from, to, rowKey, _iterator, _step, lineId, _lineId$split, _lineId$split2, planFact, operationTypeId, typeToQuery, query, queryKey, res, forecastChartData, sum, chartDataLength, i;

      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              rootGetters = _ref4.rootGetters, rootState = _ref4.rootState;
              _ref5 = _arguments.length > 1 && _arguments[1] !== undefined ? _arguments[1] : {}, lineIds = _ref5.lineIds, _ref5$updateCache = _ref5.updateCache, updateCache = _ref5$updateCache === void 0 ? false : _ref5$updateCache;
              chartData = [];
              chartSums = {};
              from = rootState.queryMirrored.from;
              to = rootState.queryMirrored.to; // const datesChanged = lastFromTo !== from + '#' + to

              lastFromTo = from + '#' + to;
              rowKey = lastFromTo;
              _iterator = _createForOfIteratorHelper(lineIds);
              _context3.prev = 9;

              _iterator.s();

            case 11:
              if ((_step = _iterator.n()).done) {
                _context3.next = 30;
                break;
              }

              lineId = _step.value;
              _lineId$split = lineId.split('_'), _lineId$split2 = _slicedToArray(_lineId$split, 2), planFact = _lineId$split2[0], operationTypeId = _lineId$split2[1];
              typeToQuery = planFact === 'FACT' ? 'F' : 'L';
              query = {
                'shop_id': rootGetters['queryMirrored/getOneDep'],
                'dt_from': from,
                'dt_to': to,
                'operation_type_id': operationTypeId,
                'type': typeToQuery
              };
              queryKey = JSON.stringify(query);
              res = void 0; // getting chart data

              if (!(!cachedChartData[queryKey] || updateCache)) {
                _context3.next = 24;
                break;
              }

              _context3.next = 21;
              return API_REQUEST('getForecastChartData', query);

            case 21:
              res = _context3.sent;
              forecastChartData = res[1] || [];
              cachedChartData[queryKey] = [lineId].concat(_toConsumableArray(forecastChartData.map(function (item) {
                return item['value'];
              })));

            case 24:
              // getting chart sums
              if (!cachedSum[queryKey] || updateCache) {
                sum = 0;
                chartDataLength = cachedChartData[queryKey].length;

                for (i = 1; i < chartDataLength; i++) {
                  // using 'for' to speed up
                  sum += cachedChartData[queryKey][i];
                }

                cachedSum[queryKey] = sum;
              }

              chartSums[lineId] = cachedSum[queryKey]; // getting row data ('x')

              /*
               (!cachedRowData[rowKey]) {
                cachedRowData[rowKey] = ['x', ...res[1].map(item => new Date(item['dttm_forecast']))]
              }
              */

              if (res && res[1].length) cachedRowData[rowKey] = ['x'].concat(_toConsumableArray(res[1].map(function (item) {
                return new Date(item['dttm_forecast']);
              })));
              chartData.push(cachedChartData[queryKey]);

            case 28:
              _context3.next = 11;
              break;

            case 30:
              _context3.next = 35;
              break;

            case 32:
              _context3.prev = 32;
              _context3.t0 = _context3["catch"](9);

              _iterator.e(_context3.t0);

            case 35:
              _context3.prev = 35;

              _iterator.f();

              return _context3.finish(35);

            case 38:
              // if (chartData || firstTime) chartData.push(cachedRowData[rowKey])
              chartData.push(cachedRowData[rowKey] || ['x']);
              return _context3.abrupt("return", {
                columns: chartData,
                chartSums: chartSums
              });

            case 40:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[9, 32, 35, 38]]);
    }))();
  },
  getChartDataUpdated: function getChartDataUpdated(_ref6) {
    var _arguments2 = arguments;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
      var rootGetters, rootState, _ref7, lineIds, _ref7$updateCache, updateCache, chartData, chartSums, from, to, loadedChartData, xAxis;

      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              rootGetters = _ref6.rootGetters, rootState = _ref6.rootState;
              _ref7 = _arguments2.length > 1 && _arguments2[1] !== undefined ? _arguments2[1] : {}, lineIds = _ref7.lineIds, _ref7$updateCache = _ref7.updateCache, updateCache = _ref7$updateCache === void 0 ? false : _ref7$updateCache;
              chartData = [];
              chartSums = {};
              from = rootState.queryMirrored.from;
              to = rootState.queryMirrored.to;
              lastFromTo = from + '#' + to;
              /** @type {Object<string, LoadedChartData>} */

              loadedChartData = {};
              _context4.next = 10;
              return Promise.all(lineIds.map(function (lineId) {
                var _lineId$split3 = lineId.split('_'),
                    _lineId$split4 = _slicedToArray(_lineId$split3, 2),
                    planFact = _lineId$split4[0],
                    operationTypeId = _lineId$split4[1];

                var typeToQuery = planFact === 'FACT' ? 'F' : 'L';
                var query = {
                  shop_id: rootGetters['queryMirrored/getOneDep'],
                  dt_from: from,
                  dt_to: to,
                  operation_type_id: operationTypeId,
                  type: typeToQuery
                };
                var queryKey = JSON.stringify(query);

                if (requestCache[queryKey]) {
                  var forecastChartData = requestCache[queryKey];
                  cachedChartData[queryKey] = [lineId].concat(_toConsumableArray(forecastChartData.map(function (item) {
                    return item.value;
                  })));
                  loadedChartData[lineId] = {
                    forecastChartData: forecastChartData,
                    queryKey: queryKey
                  };
                  return;
                }

                return new Promise(function (resolve, reject) {
                  API_REQUEST('getForecastChartData', query).then(function (res) {
                    var forecastChartData = res[1] || [];
                    requestCache[queryKey] = forecastChartData;
                    cachedChartData[queryKey] = [lineId].concat(_toConsumableArray(forecastChartData.map(function (item) {
                      return item.value;
                    })));
                    loadedChartData[lineId] = {
                      forecastChartData: forecastChartData,
                      queryKey: queryKey
                    };
                    resolve();
                  }).catch(reject);
                });
              }));

            case 10:
              xAxis = getChartXValues(loadedChartData);
              Object.keys(loadedChartData).forEach(function (
              /** @type {string} */
              lineId) {
                var data = loadedChartData[lineId].forecastChartData;
                var dataIndexedByDate = getIndexedCollection(data, 'dttm_forecast'); // let lastValue = 0

                var result = [];
                xAxis.dateStrings.forEach(function (dateString) {
                  if (dataIndexedByDate[dateString]) {
                    result.push(dataIndexedByDate[dateString]); // lastValue = dataIndexedByDate[dateString].value
                  } else {
                    result.push({
                      value: 0,
                      // value: lastValue,
                      dttm_forecast: dateString
                    });
                  }
                });
                chartData.push([lineId].concat(_toConsumableArray(result.map(function (el) {
                  return el.value;
                }))));
              });
              chartData.push(['x'].concat(_toConsumableArray(xAxis.dates)));
              return _context4.abrupt("return", {
                columns: chartData,
                chartSums: chartSums
              });

            case 14:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }))();
  }
};
export default {
  namespaced: true,
  mutations: mutations,
  actions: actions,
  state: state
};